import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import { ReferralTemplate } from '@recruitee/http/types';

@Injectable({ providedIn: 'root' })
export class TemplateItemHttpClient {
  constructor(private httpApi: HttpApiService) {}

  public loadTemplate(id: number): Observable<ReferralTemplate> {
    return this.httpApi
      .get(`/referral/templates/${id}`)
      .pipe(map(response => response.referralTemplate));
  }

  public createTemplate(data: Partial<ReferralTemplate>): Observable<ReferralTemplate> {
    return this.httpApi
      .post(`/referral/templates`, null, {
        referral_template: data,
      })
      .pipe(map(response => response.referralTemplate));
  }

  public updateTemplate(template: {
    id: number;
    data: Partial<ReferralTemplate>;
  }): Observable<ReferralTemplate> {
    return this.httpApi
      .patch(`/referral/templates/${template.id}`, null, {
        referral_template: template.data,
      })
      .pipe(map(response => response.referralTemplate));
  }

  public deleteTemplate(id: number): Observable<any> {
    return this.httpApi.delete(`/referral/templates/${id}`);
  }

  public createOrUpdateCustomTemplate(
    offerId: number | string,
    data: ReferralTemplate,
    isCustomAssigned: boolean,
  ): Observable<ReferralTemplate> {
    const url = `offers/${offerId}/referral_templates`;
    const body = {
      referral_template: data,
    };

    const observable = isCustomAssigned
      ? this.httpApi.patch(url, null, body)
      : this.httpApi.post(url, null, body);

    return observable.pipe(map(response => response.referralTemplate));
  }

  public setAsDefault(payload: {
    templateId: number;
    isDefault: boolean;
  }): Observable<ReferralTemplate> {
    return this.httpApi
      .patch(`/referral/templates/${payload.templateId}/set_default`, null, {
        referral_template: {
          default: payload.isDefault,
        },
      })
      .pipe(map(response => response.referralTemplate));
  }

  public saveAsTemplate(
    name: string,
    category: string,
    offerId: number,
  ): Observable<ReferralTemplate> {
    return this.httpApi
      .post(`/offers/${offerId}/referral_templates/save_as_template`, null, {
        referralTemplate: {
          name,
          category,
        },
      })
      .pipe(map(response => response.referralTemplate));
  }
}
